import { render, staticRenderFns } from "./Wp_tb_order_list.vue?vue&type=template&id=b8322758&scoped=true&"
import script from "./Wp_tb_order_list.vue?vue&type=script&lang=js&"
export * from "./Wp_tb_order_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8322758",
  null
  
)

export default component.exports